// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { columnsStyles } from "@eisinc/Overrides/Widgets/ProductList/ProductListColumns";
import { buttonTransparent } from "@eisinc/XDL/PreStyle/button";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color, xScreen } from "@eisinc/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

columnsStyles.leftColumnGridItem = {
    width: [0, 0, 0, 3, 3],
    css: css`
        flex-direction: column;
        gap: 32px;
    `,
};

columnsStyles.infoCardGridItem = {
    width: [12, 6, 6, 0, 0],
};

columnsStyles.rightColumnGridItem = {
    width: [12, 12, 12, 9, 9],
};

columnsStyles.filtersDrawer = {
    headlineTypographyProps: {
        forwardAs: "p",
        size: fontConfig.singleLineRegular.size,
        weight: fontConfig.weight.medium,
        color: "text",
        css: css`
            line-height: ${fontConfig.singleLineRegular.lineHeight};
        `,
    },
    closeButtonIconProps: {
        size: 19,
    },
    cssOverrides: {
        scrim: css`
            background-color: ${color("common.black", 0.5)};
        `,
        drawerTitle: css`
            background: ${color("common.white")};
            padding: 16px 0 8px;
            margin: 0 16px;
            border-bottom: 1px solid ${color("common.border")};
            button {
                padding: 0;
            }
        `,
        headlineTypography: css`
            margin: 0;
        `,
        titleButton: css`
            ${buttonTransparent}
            padding: 8px;
            ${IconWrapper} {
                color: ${color("text.main")};
            }
            &:hover {
                ${IconWrapper} {
                    color: ${color("common.ui8")};
                }
            }
        `,

        drawerBody: css`
            width: 360px;
            background-color: ${color("common.white")};
            ${xScreen("lte", "sm")} {
                top: 0;
                height: 100%;
                width: 100%;
            }
        `,
        drawerContent: css`
            overflow-x: hidden;
            background: ${color("common.white")};
            display: flex;
            flex-direction: column;
            height: 100%;
        `,
    },
};

columnsStyles.filterWrapper = {
    css: css`
        padding: 16px;
        flex: 1;
    `,
};

columnsStyles.buttonsWrapper = {
    css: css`
        position: sticky;
        bottom: 0;
        padding-top: 16px;
        display: flex;
        justify-content: space-between;
        background: ${color("common.white")};
    `,
};

columnsStyles.cancelBtn = {
    variant: "secondary",
};
